var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocations({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78978 0.304688C2.42666 0.304688 0.503906 2.1436 0.503906 4.40305C0.503906 5.47908 0.994371 6.91002 1.96164 8.65625C2.73845 10.0583 3.63715 11.3261 4.10458 11.9569C4.18356 12.0647 4.28683 12.1524 4.40602 12.2128C4.52521 12.2732 4.65696 12.3047 4.79058 12.3047C4.92421 12.3047 5.05596 12.2732 5.17515 12.2128C5.29433 12.1524 5.39761 12.0647 5.47659 11.9569C5.94322 11.3261 6.84271 10.0583 7.61953 8.65625C8.58519 6.91056 9.07565 5.47961 9.07565 4.40305C9.07565 2.1436 7.1529 0.304688 4.78978 0.304688ZM4.78978 6.30491C4.45071 6.30491 4.11926 6.20437 3.83734 6.01599C3.55542 5.82762 3.33568 5.55987 3.20593 5.24662C3.07617 4.93336 3.04222 4.58866 3.10837 4.25611C3.17452 3.92356 3.3378 3.61809 3.57755 3.37833C3.81731 3.13858 4.12278 2.9753 4.45533 2.90915C4.78788 2.843 5.13258 2.87695 5.44583 3.00671C5.75909 3.13646 6.02683 3.3562 6.21521 3.63812C6.40358 3.92004 6.50413 4.2515 6.50413 4.59056C6.50363 5.04508 6.32286 5.48085 6.00146 5.80224C5.68006 6.12364 5.2443 6.30442 4.78978 6.30491Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocations);
export default __webpack_public_path__ + "static/media/locations.73d1649742bd03fc3c8bd3e146266163.svg";
export { ForwardRef as ReactComponent };